import apiSlice from "./apiSlice";

const claimsAndChangeOrderDashboardSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getClaimsKpi: builder.query({
      query: ({ projectId }) => ({
        url: `claims/kpi`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsKpi"],
    }),

    getChangeKpi: builder.query({
      query: ({ projectId }) => ({
        url: `change/kpi`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ChangeKpi"],
    }),

    getClaimsValue: builder.query({
      query: ({ projectId }) => ({
        url: `claims/value`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsValue"],
    }),

    getClaimsOpenAging: builder.query({
      query: ({ projectId }) => ({
        url: `claims/open-aging`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsOpenAging"],
    }),

    getClaimsOpenByContractor: builder.query({
      query: ({ projectId }) => ({
        url: `claims/open-by-contractor`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsOpenByContractor"],
    }),

    getClaimsFilter: builder.query({
      query: (params) => ({
        url: `claims/filter`,
        params,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsFilter"],
    }),

    getClaimsImpact: builder.query({
      query: ({ projectId }) => ({
        url: `claims/impact`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ClaimsImpact"],
    }),

    getChangeImpact: builder.query({
      query: ({ projectId }) => ({
        url: `change/impact`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ChangeImpact"],
    }),

    getChangeByContractor: builder.query({
      query: ({ projectId }) => ({
        url: `change/by-contractor`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["ChangeByContractor"],
    }),
  }),
});

export const {
  useGetClaimsKpiQuery,
  useGetClaimsValueQuery,
  useGetClaimsOpenAgingQuery,
  useGetClaimsOpenByContractorQuery,
  useGetClaimsFilterQuery,
  useGetClaimsImpactQuery,
  useGetChangeImpactQuery,
  useGetChangeByContractorQuery,
  useGetChangeKpiQuery,
} = claimsAndChangeOrderDashboardSlice;

export default claimsAndChangeOrderDashboardSlice;
